export default "__VITE_ASSET__hrIls_ob__"